var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:("vertical-expander " + (this.type === 'media' ? '--left':'--right')),on:{"click":_vm.handleClick}},[_c('span',{staticClass:"vertical-text"},[_vm._v(_vm._s(_vm.text))])])}
var staticRenderFns = []

export { render, staticRenderFns }